<script setup lang="ts">

import { VehicleHeaderRow }  from "@app/MyGarage/Components/Utilities";
import type { IConciergeCategory } from "@app/MyGarage";

const model = defineModel<IConciergeCategory>( { required: true } );

</script>

<template>

    <div class="bg-gray-800 rounded-lg overflow-hidden transition-colors duration-300"
         :class="{ 'bg-gray-700': model.isExpanded }">

        <div class="p-4 3xl:p-6 !pb-4 cursor-pointer">
            <div @click="model.isExpanded = !model.isExpanded">
                <div class="text-sm lg:text-base w-full
                            flex items-center justify-start gap-4">
                    <div class="flex flex-col flex-1">
                        <h1 class="flex-1 flex flex-col text-base lg:text-lg 3xl:text-xl">
                            Need Roadside Assistance?
                        </h1>
                        <span class="opacity-60 mt-1 text-xs lg:text-sm 3xl:text-lg">
                            Roadside assistance when you need it 24/7, call us if you need help
                        </span>
                    </div>
                    <ExpandButton v-model="model.isExpanded" 
                                  class="absolute top-0 right-0 text-2xl pointer-events-none" />
                </div>
            </div>
        </div>

        <!-- ITEMS GROUP -->
        <div v-if="model.isExpanded && model.items.length > 0" 
             class="group/item
                    bg-gray-850/30">
            <div v-for="item in model.items"
                 class="border-t dark:border-gray-900/50 px-4 lg:px-4">
                <VehicleHeaderRow class="!py-2">
                    <RouterLink class="text-sm lg:text-base w-full h-12
                                       flex items-center justify-start gap-4"
                                :to="item.path!">
                        <div class="rounded-full aspect-square -mx-2 opacity-80
                                    w-10 h-10 flex items-center justify-center">
                            <Icon :name="item.icon" class="text-2xl"/>
                        </div>
                        <h1 class="flex-1 text-xs lg:text-sm 3xl:text-base">
                            {{ item.title }}
                        </h1>
                        <div class="flex items-center !p-0">
                            <span class="text-xs uppercase text-primary-500 dark:text-gray-500 tracking-normal">More</span>
                            <Icon name="chevron-right" class="text-2xl" />
                        </div>
                    </RouterLink>
                </VehicleHeaderRow>
            </div>
        </div>

        <!-- ITEMS GROUP WHEN THERE ARE NO ITEMS IN THE CATEGORY -->
        <div v-else-if="model.isExpanded && model.items.length == 0" 
             class="bg-gray-850 px-4 lg:px-6
                    border-y border-t-gray-900 border-b-gray-900 -mb-px">
            <VehicleHeaderRow>
                <div class="text-sm lg:text-base w-full h-12
                            flex items-center justify-start gap-4">
                    <div class="rounded-full bg-gray-900/30 aspect-square -ml-2
                            p-1 w-12 h-12 flex items-center justify-center">
                        <Icon name="traffic-cone" class="text-2xl"/>
                    </div>
                    <h1 class="text-gray-500 flex-1 uppercase">Coming Soon!</h1>
                </div>
            </VehicleHeaderRow>
        </div>

        <div class="p-4 3xl:p-6 !pt-0 w-full"
             :class="{ 'dark:!bg-gray-800 !pt-4 border-t border-gray-900/50': model.isExpanded }">
            <RoadsideAssistanceButton />    
        </div>
            
    </div>

</template>